import { createSlice } from "@reduxjs/toolkit";

import type { AuthState } from "../interfaces/auth";

const initialState: AuthState = {
  isLoading: false,
  user: null,
  token: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setInitialize: (state, action) => {
      state.isLoading = false;
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    setLogout: (state) => {
      state.user = null;
      state.token = null;
    },
  },
});

export const { setAuthLoading, setInitialize, setLogout } = authSlice.actions;
export default authSlice.reducer;
